

import { Prop, Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { formatDateMixin } from "@/mixins"
import moment from 'moment';

const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_MINUTE = 60;
const { convertUtcDateTimeToLocalDateTimeString } = formatDateMixin.methods;

@Component({
})
export default class ResponseSlaBreachDisplay extends Vue {
    @Prop({ type: String, default: null }) breachAt: string | null;
    @Prop({ type: Boolean, default: false }) hasBreached: boolean | null;

    @Getter("getResponseSlaNotifyAtSecondsRemaining") responseSlaNotifyAtSecondsRemaining: number;

    private currentSeconds: number = 0;
    private shouldCountDown: number | null = null;

    private async mounted(): Promise<void> {
        if (!this.hasBreached) {
            this.currentSeconds = this.secondsUntil(this.breachAt);
            this.startCountdown();
        }
    }

    private get backgroundClass(): string {
        if (this.currentSeconds <= 0) {
            return 'breached';
        } else if (this.currentSeconds < this.responseSlaNotifyAtSecondsRemaining) {
            return 'warning';
        } else {
            return 'nowarning';
        }
    }

    private get timerIconClass(): string {
        return (this.currentSeconds > 0 && this.currentSeconds < this.responseSlaNotifyAtSecondsRemaining) ? "animate-fade" : "";
    }

    private beforeDestroy(): void {
        this.clearCountdownInterval();
    }

    private startCountdown(): void {
        this.shouldCountDown = window.setInterval(this.decrementSeconds, 1000);
    }

    private get formattedTime(): string {
        return this.formatTime(this.currentSeconds);
    }

    private secondsUntil(date: string): number {
        var convertedDate = new Date(convertUtcDateTimeToLocalDateTimeString(date));
        const timeDifference = convertedDate.getTime() - new Date().getTime();
        const seconds = Math.floor(timeDifference / 1000);

        return seconds >= 0 ? seconds : 0;
    }

    private decrementSeconds(): void {
        if (this.currentSeconds > 0) {
            this.currentSeconds--;
        } else {
            this.currentSeconds = 0;
            this.clearCountdownInterval();
         }
    }

    private clearCountdownInterval(): void {
        if (this.shouldCountDown !== null) {
            window.clearInterval(this.shouldCountDown);
            this.shouldCountDown = null;
        }
    }

    private formatTime(seconds: number): string {
        const hours = Math.floor(seconds / SECONDS_IN_HOUR);
        const minutes = Math.floor((seconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
        const remainingSeconds = seconds % SECONDS_IN_MINUTE;

        const hh = String(hours).padStart(2, '0');
        const mm = String(minutes).padStart(2, '0');
        const ss = String(remainingSeconds).padStart(2, '0');

        return `${hh}:${mm}:${ss}`;
    }
}
